import React from "react";
import ApiCard from "../components/ApiCard";
export default function GatewayTest() {
    return (
        <ApiCard

            title="Gateway Session"

            description="Generate ABDM Gateway Access Token"

            url="abdm/gateway-session/"

            method="POST"

            buttonText="Generate Gateway Session"

            payload={{}}

            onSuccess={(data) => {
                console.log("Gateway Token Generated", data);
            }}

        />
    );
}